import { projectManagementApi } from '@/includes/projectManagementApi';

const pmMilestoneService = {
  async listMilestones(projectId) {
    const response = await projectManagementApi.get(`/projects/${projectId}/milestones`);
    return response.data;
  },

  async getMilestone(projectId, id) {
    const response = await projectManagementApi.get(`/projects/${projectId}/milestones/${id}`);
    return response.data;
  },

  async createMilestone(projectId, payload) {
    const response = await projectManagementApi.post(
      `/projects/${projectId}/milestones`,
      payload,
    );
    return response.data;
  },

  async updateMilestone(projectId, id, payload) {
    const response = await projectManagementApi.patch(
      `/projects/${projectId}/milestones/${id}`,
      payload,
    );
    return response.data;
  },

  async updateMilestoneStatus(projectId, id, payload) {
    const response = await projectManagementApi.patch(
      `/projects/${projectId}/milestones/${id}/status`,
      payload,
    );
    return response.data;
  },

  async deleteMilestone(projectId, id) {
    const response = await projectManagementApi.delete(
      `/projects/${projectId}/milestones/${id}`,
    );
    return response.data;
  },
};

export default pmMilestoneService;
